<div
  class="flex justify-center items-center w-full h-full bg-quaternary bg-blend-multiply bg-cover bg-no-repeat bg-clip-padding bg-login-background">
  <div
    class="flex flex-col items-center bg-primary w-[488px] h-[635px] pt-[90px] pr-[32px] pl-[32px] rounded-container">
    <img class="w-[213px] h-[86px] mb-[124px]" src="../../../assets/images/logo.png" alt="logo">
    <form [formGroup]="loginForm" class="w-full">
      <div class="input-login flex justify-start items-center mb-[13px]">
        <i class="fal fa-circle-user icon"></i>
        <input formControlName="user" type="text" placeholder="Usuario">
      </div>
      <div class="input-login flex justify-start items-center mb-[24px]">
        <i class="fal fa-lock icon"></i>
        <input formControlName="password" [type]="showingPassword ? 'text' : 'password'" placeholder="Contraseña">
        <i class="fal fa-eye pass-eye" *ngIf="!showingPassword" (click)="showingPassword = !showingPassword"></i>
        <i class="fal fa-eye-slash pass-eye" *ngIf="showingPassword" (click)="showingPassword = !showingPassword"></i>
      </div>
    </form>

    <app-accent-button class="h-15" text="Entrar" [selected]="true" class="w-full" (click)="doLogin()"></app-accent-button>

    <p class="font-['Roboto-Regular'] text-[18px] text-danger mt-[12px]">{{errorMessage}}</p>
  </div>
</div>